import _ from 'underscore';
import React from 'react';

class MainView extends React.Component {
  static propTypes = {
    initialViewType: React.PropTypes.func.isRequired,
    initialViewData: React.PropTypes.object,
  }

  state = {
    viewType: this.props.initialViewType,
    viewData: this.props.initialViewData,
  }

  setView = (viewType, viewData) => {
    this.setState({ viewType, viewData });
  }

  render() {
    let viewData = _.extend({}, this.state.viewData, {
      setView: this.setView
    });
    return React.createElement(this.state.viewType, viewData);
  }
}

export default MainView;




// WEBPACK FOOTER //
// ./app/javascript/components/application/MainView.jsx